import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import * as R from 'ramda';

import {
  DataBlocks,
  Menu,
  I18n,
  MyBeelineBanner,
} from 'components';

import ConnectedServices from './containers/ConnectedServices';
import Subscriptions from './containers/Subscriptions';
import { fetchData } from './actions';
import styles from './styles.pcss';
import { withViewAnalytics } from '../../utils/hocs/withViewAnalytics';

const cx = classNames.bind(styles);

const entries = [
  {
    id: 0,
    label: <I18n path="services.servicesTitle" />,
    component: <ConnectedServices />,
    dataKey: 'ConnectedServices',
  },
  {
    id: 1,
    label: <I18n path="services.subscriptionsPartnersTitle" />,
    component: <Subscriptions type="partners" />,
    dataKey: 'Subscriptions',
  },
  {
    id: 2,
    label: <I18n path="services.subscriptionsEntertainmentsTitle" />,
    component: <Subscriptions type="fun" />,
    dataKey: 'Subscriptions',
  },
];

class Services extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeEntry: entries[0],
    };
  }

  render() {
    const { isBlocked } = this.props;
    const { activeEntry } = this.state;

    return (
      <DataBlocks.Container>
        {isBlocked && (
          <DataBlocks.Block
            className="attention"
            title={(
              <I18n
                className={cx('blockMessage')}
                path="services.blockMessage"
              />
            )}
          />
        )}

        <MyBeelineBanner
          text="Управление услугами — в вашем смартфоне! Качайте приложение «Мой билайн» и действуйте"
          images={{
            iOS: '//static.beeline.ru/upload/images/mlk/images/mpBanner/ios-services.png',
            Android: '//static.beeline.ru/upload/images/mlk/images/mpBanner/android-services.png',
          }}
        />

        <DataBlocks.Block
          title={<I18n path="services.title" />}
          refreshAction={() => this.props.fetchData([activeEntry.dataKey])}
        >
          <Menu
            entries={entries}
            activeEntry={entries.indexOf(activeEntry)}
            onEntryClick={(entry) => this.setState({ activeEntry: entry })}
          />
          {activeEntry.component}
        </DataBlocks.Block>
      </DataBlocks.Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    isBlocked:
      R.path(['services', 'status', 'data', 'status'], state) === 'Blocked',
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchData }, dispatch);

Services.propTypes = {
  isBlocked: PropTypes.bool,
  fetchData: PropTypes.func,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withViewAnalytics,
)(Services);
